import searchIcon from '@disy/cadenza-icons/search.svg';
import { icon } from '@disy/lib/icon';
import { createIconButton } from '@disy/ui/button';

import type { SelectInitializationOptions } from 'ui/select/select';
import { Select } from 'ui/select/select';

import i18n from './messages.properties';

export function createSelectWithSearchButton(options?: Omit<SelectInitializationOptions, 'elementLeft'>) {
  const select: Select = new Select({
    ...options,
    elementLeft: createIconButton(icon(searchIcon), i18n('searchButton'), {
      variant: 'borderless',
      tabIndex: -1,
      onclick: () => select.open(),
    }),
  });
  select.searchInput!.setAttribute('aria-label', i18n('searchButton'));
  return select;
}
